






























































import mixins from 'vue-typed-mixins';
import OversightUtils, {
  OversightOrganizationType,
} from '../../utils/OversightUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => OversightOrganizationType,
    },
  },
  computed: {
    childOptions(): any {
      return this.types?.map((type) => ({
        text: this.$translate(type.name),
        value: type.id,
      }));
    },
  },
  data: function(): {
    types?: OversightOrganizationType[];
  } {
    return {
      types: undefined,
    };
  },
  async mounted() {
    try {
      this.types = await OversightUtils.api.type.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
});
